import React, {
  type FocusEventHandler,
  type ForwardedRef,
  forwardRef,
  type ReactNode,
} from "react";
import { Trigger } from "@radix-ui/react-tabs";
import c from "classnames/bind";

import styles from "./tab-header.module.scss";
import { type TabsVariant } from "./tabs.utils";

type TabHeaderProps = {
  "data-testid"?: string;
  index: number;
  tabId: string;
  variant: TabsVariant;
  negative?: boolean;
  onFocus: FocusEventHandler<HTMLButtonElement>;
  fullWidth?: boolean;
  children: ReactNode;
};

const cx = c.bind(styles);
const rootClassName = "purpur-tab-header";

export const TabHeader = forwardRef(
  <T extends HTMLButtonElement>(
    {
      index,
      tabId,
      variant,
      negative,
      onFocus,
      fullWidth,
      "data-testid": dataTestId,
      children,
    }: TabHeaderProps,
    ref: ForwardedRef<T>
  ) => (
    <Trigger
      id={`${tabId}-trigger`}
      className={cx(rootClassName, `${rootClassName}--${variant}${negative ? "-negative" : ""}`, {
        [`${rootClassName}--full-width`]: fullWidth,
      })}
      value={tabId}
      data-testid={dataTestId}
      data-index={index}
      ref={ref}
      onFocus={onFocus}
    >
      {children}
    </Trigger>
  )
);
